import { useOpenApiMutation } from "../../../../request/hooks/openApi/useOpenApiMutation";

const urlBackendPath =
  "/communities/{community_id}/admin/users/{user_id}/password" as const;

export const useRequestAdminDashboardResetPassword = () =>
  useOpenApiMutation<"PUT", typeof urlBackendPath>({
    urlBackendPath,
    method: "PUT",
  });
